import React from 'react';
import { Colors } from 'web-common/src/shared/styles';
import { Badge } from './Badge';

interface ITrialShefBadgeProps {
  outline?: boolean;
  className?: string;
}

export const TrialShefBadge: React.FC<ITrialShefBadgeProps> = (props: ITrialShefBadgeProps) => (
  <Badge backgroundColor={Colors.CHIVES} textColor={Colors.WHITE} {...props}>
    TRIAL SHEF
  </Badge>
);
